<template>
  <div class="aboutUs">
    <div class="allHeader">
      <div class="projectDetail">
        <div>
          <img src="../../assets/img/logo.png" alt="" class="projectImg">
        </div>
        <div class="detail">
          <div class="detailName">{{userName}}</div>
          <div class="detailPhone">{{phone}}</div>
        </div>
      </div>
      <div @click="loginOut" class="loginOut">退出</div>
    </div>
    <div class="pre_content">
      <div class="pre_title">
        <span>我的预约</span>
        <span @click="checkMore(4)">查看更多>></span>
      </div>
      <div class="my_finish">
        <div class="finishImg" @click="enterAllDetail(3)">
          <van-badge :content="countDw">
            <img src="../../assets/img/my-finish.png" alt="">
          </van-badge>
          <div>待完成</div>
        </div>
        <div class="finishImg" @click="enterAllDetail(2)">
          <van-badge :content="countYw">
            <img src="../../assets/img/my-over.png" alt="">
          </van-badge>
          <div>已完成</div>
        </div>
        <div class="finishImg" @click="enterAllDetail(1)">
          <van-badge :content="countYq">
            <img src="../../assets/img/my-cancel.png" alt="">
          </van-badge>
          <div>已取消</div>
        </div>
      </div>
    </div>
    <div class="pre_content">
      <div class="pre_title">
        <div class="other">其他</div>
      </div>
      <div class="draftList">
        <div class="finishImg" @click="enterDraftList">
          <van-badge :content="countDarft">
            <img src="../../assets/img/draft.png" alt="">
          </van-badge>
          <div>草稿箱</div>
        </div>
        <div class="finishImg" @click="enterProject">
          <img src="../../assets/img/draft.png" alt="">
          <div>项目预警</div>
        </div>
      </div>
    </div>
    <!-- <aboutCustomer></aboutCustomer>
    <aboutChild></aboutChild> -->
    <!-- <div class="addProject" @click="returnLogin" v-if="this.systemType=='1,2'||this.systemType=='2,1'">返回登录选择项</div> -->
    <div class="addProject" @click="returnLogin">返回登录选择项</div>
  </div>
</template>
<script>
import aboutChild from '../page/aboutChild/aboutChild.vue'
import aboutCustomer from '../page/aboutChild/aboutCustomer.vue'
import {
  findAppointmentCountByStatus,
  accountExit,
  findDraftsCount
} from "@/axios/api";
import {
  Dialog
} from 'vant'
export default {
  components: { aboutChild, aboutCustomer },
  data() {
    return {
      form: {},
      countDw: '',
      countYw: '',
      countYq: '',
      countDarft: '',
      userName: '',
      phone: '',
      empId: '',
      token: '',
      doctorNo: '',
      userStatus: "",
      systemType: '',
      areaType: localStorage.getItem('areaType'),
    };
  },
  created() {
    this.userName = JSON.parse(localStorage.getItem('userInfo')).userName
    this.phone = JSON.parse(localStorage.getItem('userInfo')).moblie
    this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
    this.userStatus = JSON.parse(localStorage.getItem('userInfo')).status
    this.systemType = JSON.parse(localStorage.getItem('userInfo')).systemType
    this.findCountByStatus()
    this.findCount()
  },
  methods: {
    // 添加预约返回首页
    returnLogin() {
      this.$router.push("/system");
    },
    // 点击查看更多跳转
    checkMore(val) {
      this.$router.push({
        name: "allAppointments",
        params: {
          val: val
        },
      });
    },
    // 查看操作人列表
    findCountByStatus() {
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      findAppointmentCountByStatus({
        userId: this.empId,
        doctorNo: this.doctorNo,
        userStatus: this.userStatus,
        areaType: this.areaType,
        areaCode: this.areaType,
      })
        .then((res) => {
          // console.log(res.data);
          if (res.result == true) {
            let data = res.data
            this.countDw = data.dwOpt
            this.countYw = data.ywOpt
            this.countYq = data.qxOpt
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击进入草稿箱列表
    enterDraftList() {
      this.$router.push("/darftList");
    },
    // 点击进入项目预警页面
    enterProject() {
      this.$router.push("/projectWarn");
    },
    // 统计草稿箱数量
    findCount() {
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      findDraftsCount({
        userId: this.empId,
        areaType: this.areaType,
        areaCode: this.areaType,
      })
        .then((res) => {
          // console.log(res.data);
          if (res.result == true) {
            let data = res.data
            this.countDarft = data
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 退出登录
    loginOut() {
      this.token = JSON.parse(localStorage.getItem('userInfo')).token
      Dialog.confirm({
        // title: '标题',
        confirmButtonColor: '#108ee9',
        message: '确认退出登录吗',
      })
        .then(() => {
          accountExit({
            token: this.token,
          })
            .then((res) => {
              // console.log(res.data);
              if (res.result == true) {
                this.$router.push('/login')
                localStorage.clear()
              } else {
                this.$toast.fail(res.errMsg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          // on cancel
        });

    },
    // 点击进入详情
    enterAllDetail(val) {
      console.log(val);
      this.$router.push({
        name: "allAppointments",
        params: {
          val: val
        },
      });
    },
  },
};

</script>
<style scoped>
@import "../../assets/css/aboutUs.css";
</style>



// WEBPACK FOOTER //
// src/components/page/aboutUs.vue